const URL_WITH_PROTOCOL_VALIDATION_REGEXP = new RegExp(
	'^' +
		// protocol identifier
		'(?:(?:https?)://)' +
		'(?:' +
		// host name
		'(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
		// domain name
		'(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
		// TLD identifier
		'(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
		')' +
		// port number
		'(?::\\d{2,5})?' +
		// resource path
		'(?:[/?#]\\S*)?' +
		'$',
	'i',
);

export function isUrlWithProtocol(url: string) {
	return URL_WITH_PROTOCOL_VALIDATION_REGEXP.test(url);
}

interface ValidateUrlRestrictions {
	extensions: string[];
	protocol: 'http' | 'https';
}

export default (url: string, { extensions, protocol }: ValidateUrlRestrictions) => {
	try {
		const parsedUrl = new URL(url);

		const extensionWithDot = /\.[^/.]+$/.exec(parsedUrl.pathname)?.[0] ?? '';

		return (
			parsedUrl.protocol === `${protocol}:` &&
			extensions.map((ext) => ext.toLowerCase()).includes(extensionWithDot.toLowerCase())
		);
	} catch {
		return false;
	}
};
